/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'warning': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M469.333 469.333V768a42.667 42.667 0 0085.334 0V469.333a42.667 42.667 0 00-85.334 0zm42.667-128a64 64 0 10-64-64 64 64 0 0064 64zm0 640A469.333 469.333 0 11981.333 512 469.333 469.333 0 01512 981.333z" _fill="#333"/>'
  }
})
